type UseScheduleScriptV2Props = {
	handleNext: () => void;
};

export enum ScriptRedirectToEnum {
	SCHEDULE = 'AGENDAMENTO',
	CUSTOMER_CENTER = 'CENTRAL_ATENDIMENTO',
}

export type {UseScheduleScriptV2Props};
